import { useState } from "react";
import { useIntl } from "react-intl";
import { TGetCandidateContractsCollectionItem } from "../../../../../../api/contract/apiListCandidateContracts";
import { useAuthUser } from "../../../../../../reducers/hooks/useAuthUser";
import { CONTRATO_ESTADO_FIN_DE_CONTRATO } from "../../../../../../util/defaults/contrato";
import ContractFieldCell from "../ContractFieldCell/ContractFieldCell";
import EditEndNoteDialog from "../EditEndNoteDialog/EditEndNoteDialog";
import EndNoteHistoryDialog from "../EndNoteHistoryDialog/EndNoteHistoryDialog";

type TEndNoteCellProps = {
  contract: TGetCandidateContractsCollectionItem;
};

const EndNoteCell = ({ contract }: TEndNoteCellProps) => {
  const { formatMessage } = useIntl();
  const { permissions } = useAuthUser();
  const [editOpen, setEditOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);

  const isFinished = contract.Estado === CONTRATO_ESTADO_FIN_DE_CONTRATO;
  const canEdit = isFinished && permissions.canEditContractEndNote;

  return (
    <>
      <ContractFieldCell
        value={contract.A_ade_nota_del_candidato_a}
        minValueWidth="14rem"
        showEdit={canEdit}
        showHistory={isFinished}
        onEdit={() => setEditOpen(true)}
        onHistory={() => setHistoryOpen(true)}
        editLabel={formatMessage({
          id: "EndNote.Editar nota",
          defaultMessage: "Editar nota",
        })}
        historyLabel={formatMessage({
          id: "EndNote.Ver histórico de la nota",
          defaultMessage: "Ver histórico de la nota",
        })}
      />
      {isFinished && (
        <EndNoteHistoryDialog
          open={historyOpen}
          contractId={contract.id}
          contractName={contract.Name}
          onClose={() => setHistoryOpen(false)}
        />
      )}
      {canEdit && (
        <EditEndNoteDialog
          open={editOpen}
          contractId={contract.id}
          contractName={contract.Name}
          currentValue={contract.A_ade_nota_del_candidato_a}
          onClose={() => setEditOpen(false)}
        />
      )}
    </>
  );
};

export default EndNoteCell;
